module.exports = __webpack_public_path__ + "img/Part2.de17119.svg";